// MUI
import { Box, ImageList, ImageListItem, Stack } from "@mui/material";

// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton.tsx";

// Icons
import { ArrowLeftIcon, ArrowRightIcon } from "@mui/x-date-pickers";

type ImageCarouselProps = {
	images: { src: string; alt?: string }[];
	currentIndex: number;
	onChangeImageIndex: (index: number) => void;
};

export default function ImageCarousel(props: Readonly<ImageCarouselProps>) {
	const handleNext = () => {
		const idx = (props.currentIndex + 1) % props.images.length;
		props.onChangeImageIndex(idx);
	};

	const handlePrevious = () => {
		const idx = (props.currentIndex - 1 + props.images.length) % props.images.length;
		props.onChangeImageIndex(idx);
	};

	return (
		<Box display="flex" flexDirection="column" alignItems="center" position={"relative"} pb={5}>
			<Stack direction="row" spacing={2} alignItems={"center"}>
				<SimpleIconButton
					onClick={handlePrevious}
					disabled={props.currentIndex === 0}
					icon={<ArrowLeftIcon />}
					className={"!h-[50px] !w-[50px] !text-[#666666]"}
				/>
				<ImageList cols={1} rowHeight="auto" className="!ml-0">
					<ImageListItem className="items-center">
						<img
							src={props.images[props.currentIndex].src}
							alt={props.images[props.currentIndex].alt ?? `Image ${props.currentIndex + 1}`}
							style={{ height: "85%", width: "85%" }}
						/>
					</ImageListItem>
				</ImageList>
				<SimpleIconButton
					onClick={handleNext}
					disabled={props.currentIndex === props.images.length - 1}
					icon={<ArrowRightIcon />}
					className={"!h-[50px] !w-[50px] !text-[#666666] !ml-0"}
				/>
			</Stack>
		</Box>
	);
}
